module.exports = __webpack_public_path__ + "media/images/payments/jcb-dark-1b602c9fbb8dd47e2e4891df45f94871.svg";